export type GetLanguage = () => Promise<string>;
